export default {
  ENABLED: 'enabled',
  PENDING_SALE: 'pending-sale'
}
